import { canViewSales, canViewTeam, isAdmin } from '../utils/roles';
import { SPECIAL_USER_EMAIL } from '../utils/constants';

// Stable URLs. Route guards and the API remain responsible for access control.
export function workspaceNavigation(user) {
  const admin = isAdmin(user);
  const special = user?.email?.toLowerCase() === SPECIAL_USER_EMAIL.toLowerCase();
  const page = (path, key) => ({ path, key });
  return [
    { id: 'overview', icon: 'overview', key: user?.role === 'rep' ? 'today' : 'overview', pages: [page('/overview', 'workday'), page('/dashboard', 'visits')] },
    { id: 'planning', icon: 'planning', key: 'planning', pages: [page('/calendar', 'calendar'), page('/send-location', 'location'), page('/map', 'myRoute')] },
    ...(canViewTeam(user) ? [{ id: 'team', icon: 'team', key: 'team', pages: [page('/team', 'teamOverview'), page('/reps-map', 'teamMap')] }] : []),
    { id: 'contacts', icon: 'contacts', key: 'contacts', pages: [page('/doctors', 'doctors'), page('/pharmacies', 'pharmacies'), ...(admin ? [page('/hospitals', 'hospitals')] : [])] },
    { id: 'analytics', icon: 'analytics', key: 'analytics', pages: [page('/reports', 'reports'), page('/coverage', 'coverage')] },
    ...(canViewSales(user) ? [{ id: 'commerce', icon: 'commerce', key: 'commerce', pages: [page('/analytics/sales', 'sales'), page('/inventory', 'inventory'), page('/analytics/sales-lite', 'salesDetail')] }] : []),
    { id: 'materials', icon: 'materials', key: 'materials', pages: [page('/catalog', 'catalog')] },
    ...(admin || special ? [{ id: 'administration', icon: 'administration', key: 'administration', secondary: true, pages: [
      ...(admin ? [page('/users', 'users'), page('/specialities', 'specialities'), page('/import', 'import'), page('/doctors/cleanup', 'cleanup'), page('/changelog', 'changelog')] : []),
      ...(special ? [page('/register', 'register')] : []),
    ] }] : []),
    { id: 'profile', key: 'profile', hidden: true, pages: [page('/profile', 'profile'), page('/change-password', 'password')] },
  ];
}

export function routeContext(groups, pathname) {
  for (const group of groups) {
    const page = group.pages.find(item => item.path === pathname);
    if (page) return { group, page };
  }
  return null;
}

export function searchablePages(groups, query, t) {
  const normalized = query.trim().toLocaleLowerCase();
  return groups.flatMap(group => group.pages.map(page => ({ ...page, group })))
    .filter(page => !normalized || `${t(`workspace.pages.${page.key}`)} ${t(`workspace.nav.${page.group.key}`)} ${page.path}`.toLocaleLowerCase().includes(normalized));
}
